import { Component } from 'react';

import IconBag from '../../../assets/svg/IconBag';
import { translate } from '../../../i18n';
import { S } from './ProductListSection.style';

export default class ProductListHeader extends Component {
  shouldComponentUpdate() {
    return false;
  }

  render() {
    return (
      <S.ListHeaderContainer>
        <IconBag size={21} />
        <S.ListHeaderTitle>{translate('product-details')}</S.ListHeaderTitle>
      </S.ListHeaderContainer>
    );
  }
}
